<script lang="ts" setup>
    import { richTextResolver } from '@storyblok/richtext';
    const props = defineProps<{ blok: ShopTeaserStoryblok }>();
    // @ts-expect-error - storyblok richtext type does not match type wanted by richtext resolver
    const textContent = computed(() => richTextResolver().render(props.blok.Text));
</script>

<template>
    <NuxtLink
        v-if="props.blok.Link"
        v-editable="props.blok"
        :to="useStoryblokUrl(props.blok.Link)"
        class="shop-teaser"
    >
        <StoryblokImage
            :media="props.blok.Media"
            type="mainPicture"
            :alt="props.blok.Media.alt ? props.blok.Media.alt : ''"
        />

        <div
            class="content-wrapper"
            :class="props.blok.alignRight ? '--align-right' : ''"
        >
            <div
                class="content"
                :class="props.blok.ButtonText ? '' : '--no-button'"
            >
                <h2>
                    <span
                        v-if="blok.Subheader"
                        class="sub-header"
                    >
                        {{ props.blok.Subheader }}
                    </span>
                    {{ props.blok.Header }}
                </h2>
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="text-wrapper"
                    v-html="textContent"
                ></div>
                <!-- eslint-enable vue/no-v-html -->

                <PrimaryButton
                    v-if="props.blok.Link"
                    :button-text="props.blok.ButtonText"
                    :button-href="useStoryblokUrl(props.blok.Link)"
                    :has-icon="true"
                    product-button
                />
            </div>
        </div>
    </NuxtLink>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/teaser/shop-teaser.scss';
</style>
